<template>
  <div id="user-edit">
    <Modal v-model="modal.visible" :title="modal.title" footer-hide :width="400">
      <IForm :key="modal.visible" :model="edit" :elem="userElem" :rules="userRule" :loading="loading.form"
        :btn-loading="loading.btn" :width="800" :label-width="100" button button-text="取消" @on-submit="handleSubmit"
        @on-click="modal.visible = false" />
      <!-- IForm -->
    </Modal>
  </div>
</template>
<script>
import {
  _editUser, // 创建编辑
  _getUserById,
} from "@/services/manage/users";

let _this = null;

export default {
  name: "UserEdit",
  props:{
    roles: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      // 模态框属性
      modal: {
        title: "",
        visible: false
      },
      // 表单数据
      edit: {
        name: "",
        realName: "",
        phone: "",
        roleId: "",
        password: "",
        status: ""
      },
      init: "",
      loading: {
        form: false,
        btn: false
      },
      userElem: [],
      userRule: {
        name: [
          {required: true, message: '用户名不能为空', trigger: 'blur'},
          {pattern: new RegExp('^([a-zA-Z]){1,15}@(\\d{1,11})$'),message: '账号名格式必须为 字母 + @ + 数字'},
          {minlength:15,maxlength:18,message:"账号长度必须为6-30位",trigger: 'blur'}
        ],
        realName: [
          {
            required: true,
            message: "真实姓名不能为空",
            trigger: "blur"
          }
        ],
        roleId: [
          {
            required: true,
            message: "请选择角色",
            trigger: "change",
            type:'number'
          }
        ],
        status: [
          {
            required: true,
            message: "请选择用户状态",
            trigger: "change",
            type:'number'
          }
        ],
        password: [
          { validator:(rule, value, callback) => {
              if ((!_this.edit.id || _this.edit.id === '') &&  (!value ||  value === '')) {
                callback(new Error('用户密码不能为空'));
              } else {
                callback();
              }
            }, trigger: 'blur' }
        ],
      },
    };
  },
  mounted() {
    _this = this;
    this.init = Object.assign({}, this.edit); // 复制初始表单数据
  },
  methods: {
    setFormEle(){
      this.userElem=[
        {
          label: "用户名",
          prop: "name",
          readonly: !!this.edit.id,
          placeholder: "请输入用户名"
        },
        {
          label: "真实姓名",
          prop: "realName",
          placeholder: "请输入真实姓名"
        },
        {
          label: "联系方式",
          prop: "phone",
          placeholder: "输入联系方式",
        },
        {
          label: "角色",
          prop: "roleId",
          placeholder: "请选择",
          element: "select",
          option: this.$props.roles
        },
        {
          label: "密码",
          prop: "password",
          type:"text",
          placeholder: "请输入密码",
        },
        {
          label: "状态",
          prop: "status",
          placeholder: "选择状态",
          element: "select",
          option: [
            {
              label: "启用",
              value: 1
            }, {
              label: "禁用",
              value: 2
            }
          ]
        },
      ]
    },
    /**
     * 显示模态框
     * @param  {string} title 模态框标题名称
     * @param  {object} row 当前行数据
     */
    handleModal(isCreate,title, row) {
      this.modal = {
        title: title,
        visible: true
      };
      if (isCreate) {
        this.handleCreate(); // 创建
        this.setFormEle();
      } else {
        this.handleEdit(row); // 编辑

      }
      this.$forceUpdate();
    },
    // 创建
    handleCreate() {
      this.edit = Object.assign({}, this.init);
    },
    // 编辑
    handleEdit(row) {
      this.loading.form = true;
      const params = {id: row.id};
      _getUserById(params).then(res =>{
        row = res.data;
        const edit = Object.assign({}, row);
        // row.roleId = parseInt(row.roleId);
        this.edit = {
          ...edit,
          row
        };
        this.setFormEle();
        this.loading.form = false;
        console.log(edit, 'edit');
        this.$forceUpdate();
      })
    },
    // 表单提交
    handleSubmit() {
      this.$Loading.start();
      this.loading.btn = true;
      const payload = this.edit;
      // 模拟异步请求(编辑 Or 新增)
      _editUser(payload)
        .then(res => {
          if (res.errcode === 1) {
            this.$message.success("保存成功");
            this.$emit("on-update");
          }else{
            this.$message.error(res.errmsg);
          }
          this.$Loading.finish();
          this.loading.btn = false;
          this.modal.visible = false;
        })
        .catch(() => {
          this.$Loading.error();
          this.loading.btn = false;
          this.modal.visible = false;
        });
    }
  }
};
</script>
<style lang="postcss" scoped>

</style>
